// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CustomerCreditSummary.css */

/* ── Root & Page Layout ── */
.ccs-page {
  height: calc(100vh - 72px);
  width: 100%;
  background-color: #f8fafc;
  font-family: "DM Sans", sans-serif;
  color: #0f172a;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  padding-top: 55px;
  box-sizing: border-box;
}

/* ── Ambient Background Blobs ── */
.ccs-bg {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}
.ccs-bg-blob-top {
  position: absolute;
  top: -20%;
  right: -10%;
  width: 50%;
  height: 50%;
  background: rgba(96, 165, 250, 0.1);
  border-radius: 50%;
  filter: blur(120px);
}
.ccs-bg-blob-bottom {
  position: absolute;
  bottom: -20%;
  left: -10%;
  width: 50%;
  height: 50%;
  background: rgba(192, 132, 252, 0.1);
  border-radius: 50%;
  filter: blur(120px);
}

/* ── Scroll Container ── */
.ccs-scroll {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  z-index: 10;
}
.ccs-inner {
  flex: 1;
  overflow-y: auto;
  padding: 12px 16px 88px;
}
@media (min-width: 640px) {
  .ccs-inner {
    padding: 16px 20px 88px;
  }
}
@media (min-width: 768px) {
  .ccs-inner {
    padding: 16px 24px 88px;
  }
}
@media (min-width: 1024px) {
  .ccs-inner {
    /* padding: 16px 32px 96px; */
  }
}

/* ── Card Wrapper ── */
.ccs-content {
  margin: 0 auto;
  width: 100%;
  max-width: 1180px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
@media (min-width: 1024px) {
  .ccs-content {
    gap: 12px;
  }
}

.ccs-card {
  border-radius: 22px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(8px);
}

/* ── Card Header ── */
.ccs-card-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-bottom: 1px solid #e2e8f0;
  padding: 12px 16px;
}
@media (min-width: 640px) {
  .ccs-card-header {
    padding: 12px 20px;
  }
}
@media (min-width: 768px) {
  .ccs-card-header {
    padding: 12px 24px;
  }
}
@media (min-width: 1024px) {
  .ccs-card-header {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
}

.ccs-customer-info {
  min-width: 0;
  flex: 1;
}
.ccs-customer-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.ccs-back-btn {
  display: inline-flex;
  height: 32px;
  width: 32px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  transition:
    border-color 0.15s,
    background 0.15s,
    color 0.15s;
}
.ccs-back-btn:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
  color: #0f172a;
}
.ccs-back-btn svg {
  width: 16px;
  height: 16px;
}

.ccs-customer-text h2 {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #020617;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (min-width: 640px) {
  .ccs-customer-text h2 {
    font-size: 22px;
  }
}

.ccs-customer-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
  font-size: 12px;
  color: #64748b;
}
@media (min-width: 640px) {
  .ccs-customer-meta {
    font-size: 14px;
  }
}
.ccs-meta-dot {
  color: #cbd5e1;
}

/* ── Balance Card ── */
.ccs-balance-card {
  width: 100%;
  border-radius: 18px;
  border: 1px solid #fde68a;
  background: linear-gradient(135deg, #fffbeb, #fefce8);
  padding: 12px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
}
@media (min-width: 640px) {
  .ccs-balance-card {
    max-width: 260px;
  }
}

.ccs-balance-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.ccs-balance-label {
  margin: 0 0 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #b45309;
}
.ccs-balance-amount {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  line-height: 1;
  color: #020617;
}
.ccs-pay-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  border-radius: 999px;
  border: 1px solid rgba(42, 113, 255, 0.3);
  background: #2a71ff;
  padding: 0 16px;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.ccs-pay-btn:hover {
  background: #1f63ea;
}

/* ── Tabs Section ── */
.ccs-tabs-section {
  padding: 12px 16px;
}
@media (min-width: 640px) {
  .ccs-tabs-section {
    padding: 12px 20px;
  }
}
@media (min-width: 768px) {
  .ccs-tabs-section {
    padding: 14px 24px;
  }
}

.ccs-tabs-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ccs-tab-list {
  display: inline-flex;
  align-items: center;
  width: fit-content !important;
  flex-wrap: wrap;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 4px;
  box-sizing: border-box;
}

.ccs-tab-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-family: inherit;
  font-weight: 500;
  border-radius: 12px;
  padding: 6px 14px;
  font-size: 12px;
  color: #64748b;
  background: transparent;
  border: none;
  cursor: pointer;
  transition:
    background 0.15s,
    color 0.15s,
    box-shadow 0.15s;
}
@media (min-width: 640px) {
  .ccs-tab-btn {
    font-size: 14px;
  }
}
.ccs-tab-btn.active-orders {
  background: #0f172a;
  color: #fff;
  box-shadow: 0 1px 4px rgba(42, 113, 255, 0.3);
}
.ccs-tab-btn.active-settlements {
  background: #0f172a;
  color: #fff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.2);
}

.ccs-tab-panel {
  display: none;
}
.ccs-tab-panel.active {
  display: block;
}

/* ══════════════════════════════════════════
   GRID-BASED DATA DISPLAY
   ══════════════════════════════════════════ */

.ccs-grid-container {
  overflow: hidden;
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  overflow-x: auto;
  min-width: 0;
}

.ccs-grid {
  display: grid;
  align-items: center;
}

/* ── Orders: 8 columns ── */
.ccs-grid-orders {
  grid-template-columns: 9% 11% 10% 17% 12% 15% 13% 13%;
  /* minmax(100px, 1fr)
    minmax(90px, 1fr)
    minmax(80px, 0.7fr)
    minmax(110px, 1fr)
    minmax(90px, 0.7fr)
    minmax(110px, 1fr)
    minmax(90px, 0.9fr)
    minmax(140px, 1.2fr);
  min-width: 780px; */
}

/* ── Settlements: 4 columns ── */
.ccs-grid-settlements {
  grid-template-columns:
    minmax(150px, 1.4fr)
    minmax(110px, 1fr)
    minmax(150px, 1.2fr)
    minmax(110px, 1fr);
  min-width: 520px;
}

/* ── Header row ── */
.ccs-grid-header {
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  position: sticky;
  top: 0;
  z-index: 1;
}
.ccs-grid-head-cell {
  padding: 10px 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  white-space: nowrap;
}

/* ── Data rows ── */
.ccs-grid-row {
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  transition: background 0.12s;
}
.ccs-grid-row:last-of-type {
  border-bottom: none;
}
.ccs-grid-row:hover {
  background: rgba(248, 250, 252, 0.7);
}

.ccs-grid-settlements.ccs-grid-row {
  cursor: default;
}

/* ── Cells ── */
.ccs-grid-cell {
  padding: 10px 12px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (min-width: 640px) {
  .ccs-grid-cell {
    font-size: 10px;
  }
}

.ccs-td-date {
  color: #475569;
}
.ccs-td-orderid {
  font-family: "DM Mono", monospace;
  color: #334155;
}
.ccs-td-count {
  font-weight: 500;
  color: #0f172a;
}
.ccs-td-cashier {
  color: #475569;
}
.ccs-td-aging {
  color: #475569;
}
.ccs-td-amount {
  font-weight: 600;
  color: #020617;
}
.ccs-td-paydate {
  color: #475569;
}

/* ── Empty State ── */
.ccs-empty-cell {
  padding: 40px 12px !important;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
  white-space: normal !important;
  /* span full width regardless of grid */
  grid-column: 1 / -1;
}
/* make the empty row span full width */
.ccs-grid-row:has(.ccs-empty-cell) {
  grid-template-columns: 1fr !important;
  min-width: unset !important;
}

/* ── Status Badges ── */
.ccs-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 6px;
  padding: 2px 10px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
  border: 1px solid;
  letter-spacing: 0.04em;
}
.ccs-badge-refunded {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}
.ccs-badge-settled {
  border-color: #a7f3d0;
  background: #ecfdf5;
  color: #047857;
}
.ccs-badge-outstanding {
  border-color: #fde68a;
  background: #fffbeb;
  color: #b45309;
}

/* ══════════════════════════════════════════
   SKELETON LOADING
   ══════════════════════════════════════════ */
.ccs-skeleton-row {
  cursor: default !important;
}
.ccs-skeleton-row:hover {
  background: transparent !important;
}

.ccs-skeleton {
  height: 13px;
  border-radius: 6px;
  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
  background-size: 200% 100%;
  animation: ccs-shimmer 1.4s infinite;
}
@keyframes ccs-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* ══════════════════════════════════════════
   PAGINATION
   ══════════════════════════════════════════ */
.ccs-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-top: 1px solid #f1f5f9;
  background: #fafafa;
  flex-wrap: wrap;
  gap: 8px;
}
.ccs-pagination-info {
  font-size: 12px;
  color: #64748b;
}
.ccs-pagination-btns {
  display: flex;
  align-items: center;
  gap: 4px;
}

.ccs-page-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  min-width: 28px;
  padding: 0 6px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition:
    background 0.12s,
    border-color 0.12s,
    color 0.12s;
}
.ccs-page-btn:hover:not(:disabled) {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #0f172a;
}
.ccs-page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.ccs-page-btn.ccs-page-num.active {
  background: #0f172a;
  border-color: #0f172a;
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/CustomerCreditSummary/CustomerCreditSummary.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B,6BAA6B;AAC7B;EACE,0BAA0B;EAC1B,WAAW;EACX,yBAAyB;EACzB,kCAAkC;EAClC,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;;EAEhB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;EAChC;AACF;;AAEA;EACE,YAAY;EACZ,OAAO;AACT;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf;;;eAGa;AACf;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,qDAAqD;EACrD,kBAAkB;EAClB,yCAAyC;EACzC,sBAAsB;AACxB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,wCAAwC;AAC1C;AACA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf;;;oBAGkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,6CAA6C;AAC/C;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA;;+CAE+C;;AAE/C;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,qDAAqD;EACrD;;;;;;;;qBAQmB;AACrB;;AAEA,iCAAiC;AACjC;EACE;;;;sBAIoB;EACpB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gCAAgC;EAChC,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,uCAAuC;EACvC,mBAAmB;AACrB;AACA,uCAAuC;AACvC;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;+CAE+C;AAC/C;EACE,0BAA0B;AAC5B;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,oCAAoC;AACtC;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;;+CAE+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf;;;eAGa;AACf;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":["/* CustomerCreditSummary.css */\n\n/* ── Root & Page Layout ── */\n.ccs-page {\n  height: calc(100vh - 72px);\n  width: 100%;\n  background-color: #f8fafc;\n  font-family: \"DM Sans\", sans-serif;\n  color: #0f172a;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n\n  padding-top: 55px;\n  box-sizing: border-box;\n}\n\n/* ── Ambient Background Blobs ── */\n.ccs-bg {\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  z-index: 0;\n}\n.ccs-bg-blob-top {\n  position: absolute;\n  top: -20%;\n  right: -10%;\n  width: 50%;\n  height: 50%;\n  background: rgba(96, 165, 250, 0.1);\n  border-radius: 50%;\n  filter: blur(120px);\n}\n.ccs-bg-blob-bottom {\n  position: absolute;\n  bottom: -20%;\n  left: -10%;\n  width: 50%;\n  height: 50%;\n  background: rgba(192, 132, 252, 0.1);\n  border-radius: 50%;\n  filter: blur(120px);\n}\n\n/* ── Scroll Container ── */\n.ccs-scroll {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n  z-index: 10;\n}\n.ccs-inner {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px 16px 88px;\n}\n@media (min-width: 640px) {\n  .ccs-inner {\n    padding: 16px 20px 88px;\n  }\n}\n@media (min-width: 768px) {\n  .ccs-inner {\n    padding: 16px 24px 88px;\n  }\n}\n@media (min-width: 1024px) {\n  .ccs-inner {\n    /* padding: 16px 32px 96px; */\n  }\n}\n\n/* ── Card Wrapper ── */\n.ccs-content {\n  margin: 0 auto;\n  width: 100%;\n  max-width: 1180px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n@media (min-width: 1024px) {\n  .ccs-content {\n    gap: 12px;\n  }\n}\n\n.ccs-card {\n  border-radius: 22px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background: rgba(255, 255, 255, 0.9);\n  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.08);\n  backdrop-filter: blur(8px);\n}\n\n/* ── Card Header ── */\n.ccs-card-header {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border-bottom: 1px solid #e2e8f0;\n  padding: 12px 16px;\n}\n@media (min-width: 640px) {\n  .ccs-card-header {\n    padding: 12px 20px;\n  }\n}\n@media (min-width: 768px) {\n  .ccs-card-header {\n    padding: 12px 24px;\n  }\n}\n@media (min-width: 1024px) {\n  .ccs-card-header {\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n  }\n}\n\n.ccs-customer-info {\n  min-width: 0;\n  flex: 1;\n}\n.ccs-customer-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.ccs-back-btn {\n  display: inline-flex;\n  height: 32px;\n  width: 32px;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #475569;\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    background 0.15s,\n    color 0.15s;\n}\n.ccs-back-btn:hover {\n  border-color: #cbd5e1;\n  background: #f8fafc;\n  color: #0f172a;\n}\n.ccs-back-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.ccs-customer-text h2 {\n  margin: 0 0 4px;\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #020617;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n@media (min-width: 640px) {\n  .ccs-customer-text h2 {\n    font-size: 22px;\n  }\n}\n\n.ccs-customer-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px 8px;\n  font-size: 12px;\n  color: #64748b;\n}\n@media (min-width: 640px) {\n  .ccs-customer-meta {\n    font-size: 14px;\n  }\n}\n.ccs-meta-dot {\n  color: #cbd5e1;\n}\n\n/* ── Balance Card ── */\n.ccs-balance-card {\n  width: 100%;\n  border-radius: 18px;\n  border: 1px solid #fde68a;\n  background: linear-gradient(135deg, #fffbeb, #fefce8);\n  padding: 12px 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  box-sizing: border-box;\n}\n@media (min-width: 640px) {\n  .ccs-balance-card {\n    max-width: 260px;\n  }\n}\n\n.ccs-balance-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n.ccs-balance-label {\n  margin: 0 0 4px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #b45309;\n}\n.ccs-balance-amount {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 1;\n  color: #020617;\n}\n.ccs-pay-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  border-radius: 999px;\n  border: 1px solid rgba(42, 113, 255, 0.3);\n  background: #2a71ff;\n  padding: 0 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #ffffff;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n.ccs-pay-btn:hover {\n  background: #1f63ea;\n}\n\n/* ── Tabs Section ── */\n.ccs-tabs-section {\n  padding: 12px 16px;\n}\n@media (min-width: 640px) {\n  .ccs-tabs-section {\n    padding: 12px 20px;\n  }\n}\n@media (min-width: 768px) {\n  .ccs-tabs-section {\n    padding: 14px 24px;\n  }\n}\n\n.ccs-tabs-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ccs-tab-list {\n  display: inline-flex;\n  align-items: center;\n  width: fit-content !important;\n  flex-wrap: wrap;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  padding: 4px;\n  box-sizing: border-box;\n}\n\n.ccs-tab-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  font-family: inherit;\n  font-weight: 500;\n  border-radius: 12px;\n  padding: 6px 14px;\n  font-size: 12px;\n  color: #64748b;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition:\n    background 0.15s,\n    color 0.15s,\n    box-shadow 0.15s;\n}\n@media (min-width: 640px) {\n  .ccs-tab-btn {\n    font-size: 14px;\n  }\n}\n.ccs-tab-btn.active-orders {\n  background: #0f172a;\n  color: #fff;\n  box-shadow: 0 1px 4px rgba(42, 113, 255, 0.3);\n}\n.ccs-tab-btn.active-settlements {\n  background: #0f172a;\n  color: #fff;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.2);\n}\n\n.ccs-tab-panel {\n  display: none;\n}\n.ccs-tab-panel.active {\n  display: block;\n}\n\n/* ══════════════════════════════════════════\n   GRID-BASED DATA DISPLAY\n   ══════════════════════════════════════════ */\n\n.ccs-grid-container {\n  overflow: hidden;\n  border-radius: 24px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  overflow-x: auto;\n  min-width: 0;\n}\n\n.ccs-grid {\n  display: grid;\n  align-items: center;\n}\n\n/* ── Orders: 8 columns ── */\n.ccs-grid-orders {\n  grid-template-columns: 9% 11% 10% 17% 12% 15% 13% 13%;\n  /* minmax(100px, 1fr)\n    minmax(90px, 1fr)\n    minmax(80px, 0.7fr)\n    minmax(110px, 1fr)\n    minmax(90px, 0.7fr)\n    minmax(110px, 1fr)\n    minmax(90px, 0.9fr)\n    minmax(140px, 1.2fr);\n  min-width: 780px; */\n}\n\n/* ── Settlements: 4 columns ── */\n.ccs-grid-settlements {\n  grid-template-columns:\n    minmax(150px, 1.4fr)\n    minmax(110px, 1fr)\n    minmax(150px, 1.2fr)\n    minmax(110px, 1fr);\n  min-width: 520px;\n}\n\n/* ── Header row ── */\n.ccs-grid-header {\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n.ccs-grid-head-cell {\n  padding: 10px 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n/* ── Data rows ── */\n.ccs-grid-row {\n  border-bottom: 1px solid #f1f5f9;\n  cursor: pointer;\n  transition: background 0.12s;\n}\n.ccs-grid-row:last-of-type {\n  border-bottom: none;\n}\n.ccs-grid-row:hover {\n  background: rgba(248, 250, 252, 0.7);\n}\n\n.ccs-grid-settlements.ccs-grid-row {\n  cursor: default;\n}\n\n/* ── Cells ── */\n.ccs-grid-cell {\n  padding: 10px 12px;\n  font-size: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n@media (min-width: 640px) {\n  .ccs-grid-cell {\n    font-size: 10px;\n  }\n}\n\n.ccs-td-date {\n  color: #475569;\n}\n.ccs-td-orderid {\n  font-family: \"DM Mono\", monospace;\n  color: #334155;\n}\n.ccs-td-count {\n  font-weight: 500;\n  color: #0f172a;\n}\n.ccs-td-cashier {\n  color: #475569;\n}\n.ccs-td-aging {\n  color: #475569;\n}\n.ccs-td-amount {\n  font-weight: 600;\n  color: #020617;\n}\n.ccs-td-paydate {\n  color: #475569;\n}\n\n/* ── Empty State ── */\n.ccs-empty-cell {\n  padding: 40px 12px !important;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 13px;\n  white-space: normal !important;\n  /* span full width regardless of grid */\n  grid-column: 1 / -1;\n}\n/* make the empty row span full width */\n.ccs-grid-row:has(.ccs-empty-cell) {\n  grid-template-columns: 1fr !important;\n  min-width: unset !important;\n}\n\n/* ── Status Badges ── */\n.ccs-badge {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 6px;\n  padding: 2px 10px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  white-space: nowrap;\n  border: 1px solid;\n  letter-spacing: 0.04em;\n}\n.ccs-badge-refunded {\n  border-color: #fecdd3;\n  background: #fff1f2;\n  color: #be123c;\n}\n.ccs-badge-settled {\n  border-color: #a7f3d0;\n  background: #ecfdf5;\n  color: #047857;\n}\n.ccs-badge-outstanding {\n  border-color: #fde68a;\n  background: #fffbeb;\n  color: #b45309;\n}\n\n/* ══════════════════════════════════════════\n   SKELETON LOADING\n   ══════════════════════════════════════════ */\n.ccs-skeleton-row {\n  cursor: default !important;\n}\n.ccs-skeleton-row:hover {\n  background: transparent !important;\n}\n\n.ccs-skeleton {\n  height: 13px;\n  border-radius: 6px;\n  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);\n  background-size: 200% 100%;\n  animation: ccs-shimmer 1.4s infinite;\n}\n@keyframes ccs-shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n/* ══════════════════════════════════════════\n   PAGINATION\n   ══════════════════════════════════════════ */\n.ccs-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  border-top: 1px solid #f1f5f9;\n  background: #fafafa;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.ccs-pagination-info {\n  font-size: 12px;\n  color: #64748b;\n}\n.ccs-pagination-btns {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.ccs-page-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 28px;\n  min-width: 28px;\n  padding: 0 6px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition:\n    background 0.12s,\n    border-color 0.12s,\n    color 0.12s;\n}\n.ccs-page-btn:hover:not(:disabled) {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n.ccs-page-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n.ccs-page-btn.ccs-page-num.active {\n  background: #0f172a;\n  border-color: #0f172a;\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
